'use strict'

export function removeCurrent(nav) {
  const accurateNavDots = nav.querySelectorAll('a.dot')
  Array.prototype.forEach.call(accurateNavDots, dot => {
    if (dot.classList.contains('dot--current')) {
      dot.classList.remove('dot--current')
    }
  })
}

export function updateCopySlider(copyWrapper, step) {
  if (copyWrapper.querySelector('.data-slide--current') !== null) {
    copyWrapper.querySelector('.data-slide--current').classList.remove('data-slide--current')
  }
  window.setTimeout(() => {
    Array.prototype.forEach.call(copyWrapper.querySelectorAll('.data-slide'), copySlide => {
      copySlide.classList.add('data-slide--hide')
    })
    copyWrapper.querySelector(`.data-slide[data-slide="${step}"]`).classList.remove('data-slide--hide')
    window.setTimeout(() => {
      copyWrapper.querySelector(`.data-slide[data-slide="${step}"]`).classList.add('data-slide--current')
    }, 10)
  }, 500)
}

export function attachEvents(slider, animation, ...animationParams) {
  const nav = slider.querySelector('nav')
  const navDots = Array.from(nav.querySelectorAll('a.dot'))

  navDots.forEach(dot => {
    dot.addEventListener('click', changeSlide.bind(this, dot, slider, nav, animation, ...animationParams), false)
    dot.setAttribute('data-handler', 'true')
  })
}

export function changeSlide(dot, slider, nav, playAnimation, ...animationParams) {
  const e = animationParams.pop(1)
  e.preventDefault()

  if (dot.getAttribute('data-handler') === 'true') {
    const step = parseInt(dot.getAttribute('data-slide'), 10)
    updateCopySlider(slider.querySelector('.wrapper'), step)
    removeCurrent(nav)
    dot.classList.add('dot--current')

    animationParams.push(step)
    playAnimation.apply(slider, animationParams)
  }
}
